import { FileText } from "lucide-react";
import type { AppInfo } from "@/shared/apps";

// Where the app sits in the shell: its tabs, "+ New" entries, settings and first steps.
export const app: AppInfo = {
  key: "invoicing",
  icon: FileText,
  tabs: [
    { to: "/invoicing/invoices", label: "nav.invoices", perm: ["invoicing.invoice.read"] },
    { to: "/invoicing/payments", label: "nav.payments", perm: ["invoicing.payment.read"] },
    { to: "/invoicing/price-lists", label: "nav.priceLists", perm: ["invoicing.price_list.read"] },
    { to: "/invoicing/expenses", label: "nav.expenses", perm: ["invoicing.expense.read"] },
    { to: "/invoicing/cheques", label: "nav.cheques", perm: ["invoicing.payment.read"] },
    { to: "/invoicing/treasury", label: "nav.treasury", perm: ["core.treasury.read"] },
  ],
  create: [
    { label: "create.invoice", to: "/invoicing/invoices/new", perm: "invoicing.invoice.create" },
    { label: "create.payment", to: "/invoicing/payments?new=1", perm: "invoicing.payment.create" },
    { label: "create.expense", to: "/invoicing/expenses?new=1", perm: "invoicing.expense.create" },
    { label: "create.receiptVoucher", to: "/invoicing/treasury?receipt=1", perm: "invoicing.voucher.create" },
    { label: "create.paymentVoucher", to: "/invoicing/treasury?payment=1", perm: "invoicing.voucher.create" },
    { label: "create.moneyTransfer", to: "/invoicing/treasury?transfer=1", perm: "core.treasury.transfer" },
  ],
  settings: { to: "/settings/invoicing", perm: ["invoicing.settings.manage"] },
  setup: { einvoice: "/settings/invoicing", first_invoice: "/invoicing/invoices/new" },
};
